import React, { useMemo } from 'react';
import TimelineWithTimeLabels from './timelineWithTimeLabels';
import BatchTimeLine from './batchTimeLine';
import LinePointWrapper from './linePointWrapper';
import { dotTimeIndicatorColor, machineTimeType } from './functions';
import DotIndicator from './dotIndicator';
import useManageBatchTimeLineWithTime from '@components/wallboard/hooks/useManageBatchTimeLineWithTime';

const BatchTimeLineWithTime = ({
  font,
  scale,
  convertTime,
  productionBatchId,
  batch,
  C,
  localTime,
  getMachineEventTimelineByBatchId,
  offset = 0,
  lineHeight = 6,
  tileWidth,
  status,
  tourId,
}) => {
  const {
    value,
    targetTimeValue,
    isTargetDuration,
    hasExceededTarget,
    remainingOrExceededTime,
    getPercent,
    scheduledTargetTotalTimeTotalInSeconds,
    paidTargetTotalTimeTotalInSeconds,
    idealTargetTotalTimeTotalInSeconds,
  } = useManageBatchTimeLineWithTime({ batch, offset });

  const allTimePoints = useMemo(
    () => [
      {
        positionPercent: getPercent(scheduledTargetTotalTimeTotalInSeconds),
        pointComponent: () => <DotIndicator {...{ scale, C, color: dotTimeIndicatorColor[machineTimeType.SCHEDULED] }} />,
      },
      {
        positionPercent: getPercent(paidTargetTotalTimeTotalInSeconds),
        pointComponent: () => <DotIndicator {...{ scale, C, size: 3, color: dotTimeIndicatorColor[machineTimeType.PAID] }} />,
      },
      {
        positionPercent: getPercent(idealTargetTotalTimeTotalInSeconds),
        pointComponent: () => <DotIndicator {...{ scale, C, color: dotTimeIndicatorColor[machineTimeType.IDEAL] }} />,
      },
    ],
    [value, scheduledTargetTotalTimeTotalInSeconds, paidTargetTotalTimeTotalInSeconds, idealTargetTotalTimeTotalInSeconds, scale, C]
  );

  return (
    <TimelineWithTimeLabels
      values={[
        { value: value },
        {
          value: targetTimeValue || null,
          Indicator: <DotIndicator {...{ scale, C, size: 4, color: dotTimeIndicatorColor[machineTimeType.SCHEDULED], hasOutline: false }} />,
        },
        {
          value: remainingOrExceededTime,
          color: hasExceededTarget ? 'Chart/Light/Warning' : undefined,
          showPlus: true,
        },
      ]}
      C={C}
      font={font}
      scale={scale}
      convertTime={convertTime}
      tourId={tourId}
    >
      <LinePointWrapper scale={scale} points={allTimePoints}>
        <BatchTimeLine
          height={lineHeight}
          productionBatchId={productionBatchId}
          batch={batch}
          scale={scale}
          C={C}
          localTime={localTime}
          getMachineEventTimelineByBatchId={getMachineEventTimelineByBatchId}
          tileWidth={tileWidth}
          status={status}
          withGaps={false}
        />
      </LinePointWrapper>
    </TimelineWithTimeLabels>
  );
};

export default BatchTimeLineWithTime;
